/**
 * Maps server-provided error codes to user-friendly error messages.
 * 
 * Intent: Translates backend error codes (ROLE_NOT_PERMITTED, OWNER_LINK_MISSING, ACCOUNT_INACTIVE)
 * into human-readable messages displayed to the user. Falls back to server-provided message
 * or generic "Login failed" if no specific error code is present.
 * 
 * @param {Object} err - Error object from login API call
 * @param {string} [err.errorCode] - Server-provided error code
 * @param {string} [err.message] - Server-provided error message
 * @returns {string} User-friendly error message
 */
export function getLoginErrorMessage(err) {
  // Use server-provided errorCode/message for specific errors
  if (err.errorCode === 'ROLE_NOT_PERMITTED') {
    return 'Access denied: Admin or Owner role required';
  }
  if (err.errorCode === 'OWNER_LINK_MISSING') {
    return 'Access denied: No owner record linked to this account';
  }
  if (err.errorCode === 'ACCOUNT_INACTIVE') {
    return 'Account inactive';
  }
  if (err.errorCode === 'SITE_ACCESS_DENIED') {
    return err.message || "This account can't sign in here. Redirecting you to the correct site…";
  }
  // Fallback to server message or default
  return err.message || 'Login failed';
}
